import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useRef } from "react";

export const CARD_SRC = "/assets/front-google-nfc-angle-cutout.webp";
export const STAND_ALT = "White acrylic NFC stand with Google logo, five gold stars, 'Review Us On Google' and a 'Tap your phone' NFC icon";
export const LOGO_SRC = "/assets/revora-logo-new.png";

export const RevoraCard = ({ className = "", tilt = true, float = true }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-12, 12]), { stiffness: 120, damping: 14 });

  const onMove = (e) => {
    if (!tilt || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => { mx.set(0); my.set(0); }}
      style={tilt ? { rotateX: rx, rotateY: ry, transformPerspective: 900 } : undefined}
      animate={float ? { y: [0, -12, 0] } : undefined}
      transition={float ? { duration: 6, repeat: Infinity, ease: "easeInOut" } : undefined}
      className={`relative ${className}`}
      data-testid="revora-card"
    >
      <img
        src={CARD_SRC}
        alt={STAND_ALT}
        className="w-full h-auto [filter:drop-shadow(0_30px_45px_rgba(10,10,10,0.28))]"
        draggable={false}
      />
    </motion.div>
  );
};
